import React, { Component } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Pagination as PaginationStrap,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import {
  renderTotal,
  calcPagesList,
  calcStartAndTo,
} from "@/util/paginationHelper";

class Pagination extends Component {
  state = {
    isDropdownOpen: false,
  };

  toggle = () => {
    this.setState(({ isDropdownOpen }) => ({
      isDropdownOpen: !isDropdownOpen,
    }));
  };

  render() {
    const { isDropdownOpen } = this.state;
    const { size, onChangeSize, page, onChangePage, total } = this.props;

    const totalPages = Math.ceil(total / size);
    const pagesList = calcPagesList(page, totalPages);
    const { start, to } = calcStartAndTo(page, size, total);

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "baseline",
        }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Dropdown isOpen={isDropdownOpen} toggle={this.toggle}>
            <DropdownToggle caret style={{ width: 65 }}>
              <span style={{ marginRight: 5 }}>{size}</span>
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={() => onChangeSize(5)}>5</DropdownItem>
              <DropdownItem onClick={() => onChangeSize(10)}>10</DropdownItem>
              <DropdownItem onClick={() => onChangeSize(25)}>25</DropdownItem>
              <DropdownItem onClick={() => onChangeSize(50)}>50</DropdownItem>
            </DropdownMenu>
          </Dropdown>

          {renderTotal(start, to, total)}
        </div>

        <PaginationStrap aria-label="Page navigation example">
          {!!pagesList.length && !pagesList.includes(1) && (
            <PaginationItem onClick={() => onChangePage(1)}>
              <PaginationLink>&laquo;</PaginationLink>
            </PaginationItem>
          )}
          {page > 1 && (
            <PaginationItem>
              <PaginationLink onClick={() => onChangePage(page - 1)}>
                &lt;
              </PaginationLink>
            </PaginationItem>
          )}
          {pagesList.map(pageNumber => (
            <PaginationItem
              active={pageNumber === page}
              key={pageNumber}
              onClick={() => pageNumber !== page && onChangePage(pageNumber)}>
              <PaginationLink>{pageNumber}</PaginationLink>
            </PaginationItem>
          ))}
          {page < totalPages && (
            <PaginationItem onClick={() => onChangePage(page + 1)}>
              <PaginationLink>></PaginationLink>
            </PaginationItem>
          )}
          {!!pagesList.length && !pagesList.includes(totalPages) && (
            <PaginationItem onClick={() => onChangePage(totalPages)}>
              <PaginationLink>&raquo;</PaginationLink>
            </PaginationItem>
          )}
        </PaginationStrap>
      </div>
    );
  }
}

export default Pagination;
